import React from 'react'
// Import CommonBanner Area
import CommonBanner from '../component/Common/CommonBanner'
// import Team Area
import TeamArea from '../component/Team'

const TeamPage = () => {
  return (
    <>
      <CommonBanner heading="Our Team" pagination="Team"/>
      <TeamArea/>
      
    </>
  )
}

export default TeamPage